import { jsx as _jsx } from "react/jsx-runtime";
import { ContestsItem } from "@bluframe/mightychroma-mightytool-ui";
import React from "react";
const Add = ({ onCancel, onSave }) => (_jsx(ContestsItem, { isAdd: true, onCancel: onCancel, onSave: onSave }));
export default Add;
